import { FEATURE_FLAGS, type FeatureFlag } from './flags';

/**
 * Plain-code entry point for feature flags (root layout, query `enabled`
 * predicates, anything outside React). Components use `useFeatureFlag`.
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return (FEATURE_FLAGS[flag] as boolean) === true;
}

/**
 * The whole map, frozen and freshly copied per call so no caller can mutate
 * the source. Intended for bulk readers such as the settings registry view.
 */
export function getFeatureFlags(): Readonly<Record<FeatureFlag, boolean>> {
  return Object.freeze({ ...FEATURE_FLAGS });
}
